import React, { FC, useState } from "react";
import { useGlobalState } from "../../context/Provider";
import { Modal, Row, Col, Form, Input, Select, Space } from "antd";
import { AddWarehosueAccess } from "../../api/WarehouseAccess";

interface AddWarehouseAccessModalProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
}

const AddWarehouseAccessModal: FC<AddWarehouseAccessModalProps> = (props) => {
  const { langState, warehouserList }: any = useGlobalState();
  const { visible, setVisible } = props;
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form] = Form.useForm();
  const { Option } = Select;

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onCreate = (values: any) => {
    const params = {
      email: values.onlyAccessibleByEmail,
      id: values.warehouse,
    };
    setConfirmLoading(true);
    AddWarehosueAccess(params).then((res: any) => {
      setConfirmLoading(false);
      if (res.status === 200 || res.status === 204) {
        setVisible(false);
        window.location.reload();
      }
    });
  };

  return (
    <Modal
      closable={false}
      visible={visible}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      width={700}
      onOk={(value: any) => {
        form.validateFields().then((values) => {
          // form.resetFields();
          onCreate(values);
        });
      }}
    >
      <Row gutter={[24, 24]}>
        <Form
          form={form}
          layout="inline"
          name="form_in_modal"
          initialValues={{ modifier: "public" }}
        >
          <Form.Item
            name="onlyAccessibleByEmail"
            label={langState.locale === "en-US" ? "Email" : " ایمیل"}
            rules={[{ type: "email" }]}
          >
            <Input style={{ width: 280 }} />
          </Form.Item>
          <Form.Item
            label="warehouse"
            name="warehouse"
            // style={{ flexDirection: "column", alignItems: "start" }}
          >
            <Select placeholder="select to warehouse">
              {warehouserList.data.map((item: any) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>

        <Col span={24}></Col>
      </Row>
    </Modal>
  );
};

export default AddWarehouseAccessModal;
